<template>
	<div class="zp-content">
		<img-upload
			class="file-upload"
			:imageUrl="designDocumentUrl"
			@downloadALink="downloadALink"
			ref="designDocumentUrl"
			:isType="2"
			:limit="9"
			title="支持扩展名：doc .docx .pdf .xls .jpg"
		></img-upload>
	</div>
</template>
<script>
import imgUpload from '@/views/components/upLoad/imgUpload.vue';
export default {
	name: 'shejidangan',
	props: [],
	components: {
		imgUpload
	},
	data() {
		return {
			designDocumentUrl: []
		};
	},
	methods: {
		// 下载
		downloadALink(file) {
			console.log(file);
			const a = document.createElement('a');
				a.href = file.url;
				// a.download = '文件名1'; // 下载后文件名
				a.setAttribute("download", file.name); 
				a.style.display = 'none';
				document.body.appendChild(a);
				a.click(); // 点击下载
				document.body.removeChild(a); // 下载完成移除元素
		},
		// 设计档案提交
		async sheJiDangAnBC() {
			let data = {
				createByName: this.$store.state.user.accountName,
				createByUuid: this.$store.state.user.accountUuid,
				bridgeUuid: global.bridgeUuid
			};
			data.designDocumentUrl = this.$refs.designDocumentUrl.getString();
			console.log(data);
			const res = await this.$api.sendPost('/biBridge/update', data);
			console.log(res);
			if (res.errcode == 0) {
				this.$message.success(res.errmsg);
				this.$emit('updateIndex', '5');
			} else {
				this.$message.error(res.errmsg);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.zp-content {
	margin-left: 40px;
	height: 700px;
	overflow: auto;
}

.file-upload {
	width: 500px;
}
</style>
